/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('global.winter')
 */
import Component, { getServerSideProps as getSnowWeatherHomePageServerSideProps } from 'pages/index';

export default Component;
export const getServerSideProps = getSnowWeatherHomePageServerSideProps;
